"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns `true` if form has no errors.
 *
 * @param errors Form values, section errors.
 */
function formErrorsToIsValid(errors) {
    var convert = function (ers) {
        if (!ers)
            return true;
        if (typeof ers === 'string' && ers.length)
            return false;
        if (Array.isArray(ers))
            return ers.reduce(function (r, v) { return r && convert(v); }, true);
        if (typeof ers === 'object')
            return !!Object.values(ers).reduce(function (r, v) { return r && convert(v); }, true);
        return true;
    };
    return convert(errors);
}
exports.default = formErrorsToIsValid;
//# sourceMappingURL=formErrorsToIsValid.js.map